<template>
    <div class="container distance">
        <div class="row">
            <div class="six columns">
                <h1>Links</h1>
            </div>
            <div class="six columns">
                <p>Meine Sammlung von Links, die ich bei meiner täglichen Arbeit ganz hilfreich finde - quasi <i>vom Entwickler für Entwickler</i>.</p>
            </div>
        </div>
        <div v-if="isEditMode === false && this.canEdit === true">
            <button class="button button-primary" @click="onClickEditButton">Edit</button>
        </div>
        <div v-if="isEditMode === true && this.canEdit === true">
            <button class="button button-blue" @click="onClickEditButton">Show</button>
        </div>
        <div class="row">
            <div class="twelve columns">
                <link-tree :can-edit="canEdit && isEditMode"></link-tree>
            </div>
        </div>
    </div>
</template>

<script>
import LinkTree from '@/components/LinkTree'

export default {
    name: 'PageLinks',
    components: { 'link-tree': LinkTree },
    data () {
        let userName = this.$parent.$data.current.user !== null ? this.$parent.$data.current.user.DisplayName : ''
        return {
            canEdit: userName !== null && userName === 'Nikolai Müller',
            isEditMode: false
        }
    },
    methods: {
        onClickEditButton: function (event) {
            this.isEditMode = !this.isEditMode
        }
    }
}
</script>

<style scoped>
    .button {
        letter-spacing: .15rem;
        /* SEE:   https://www.w3schools.com/colors/colors_gradient.asp */
        background: -webkit-linear-gradient(top, #ffffff 31%, #e8e8e8 59%);
        background: linear-gradient(to bottom, #ffffff 31%, #e8e8e8 59%);
        text-transform:none;
        font-size:1.03em;
        font-weight:600;
    }
    .button-primary {
        background-color: #009000;
        background: -webkit-linear-gradient(top, #66ff66 0%, #009900 59%);
        background: linear-gradient(to bottom, #66ff66 0%, #009900 59%);
        border: 1px solid #009900;
        font-weight:700;
    }
    .button-primary:hover {
        letter-spacing: .15rem;
        border: 1px solid darkgreen;
        background-color: #009000;
        text-shadow: -1.5px 0.5px 0.8px darkgreen;
        text-transform:none;
        font-size:1.03em;
        font-weight:700;
    }
    .button-blue {
        background-color: #0000ff;
        background: -webkit-linear-gradient(top, #9999ff 0% ,#0000ff 59%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,   #9999ff 0%, #0000ff 59%);
        border: 1px solid #3333b0;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageLinks.vue